import React, { useEffect, useRef } from "react";
import LetsDiscuss from "../components/Landing/LetsDiscuss";
import SharedBanner from "../components/Layout/SharedBanner";
import { IoGlobeOutline, IoLocation, IoMail } from "react-icons/io5";
import { FaPhone } from "react-icons/fa6";

const Contact = () => {
  const discussRef = useRef<any>(null);

  useEffect(() => {
    // Check if URL contains #discuss hash
    if (window.location.hash === "#discuss" && discussRef.current) {
      // Add a small delay to ensure the component is fully rendered
      setTimeout(() => {
        discussRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, []);

  return (
    <div className=" pb-12 md:pb-20 lg:pb-[100px]">
      <SharedBanner img={"contact"} text="CONTACT US" imgType="jpg" />

      {/* <div className="w-[95%] md:w-[85%] max-w-[1600px] mx-auto mt-8 md:mt-12 lg:mt-[60px] flex flex-col lg:flex-row justify-between gap-8 md:gap-12">
        <img
          src="/images/glassesgirl.png"
          alt="girl with glasses"
          className="w-full lg:max-w-[655px] h-[250px] md:h-[350px] lg:h-auto object-cover rounded-[20px] md:rounded-[30px]"
        />
        <div className="w-full lg:max-w-[898px] bg-primaryGreen rounded-[20px] md:rounded-[30px] p-6 md:p-8 lg:px-[48px] flex flex-col justify-center"></div>
      </div> */}

      <div ref={discussRef}>
        <LetsDiscuss />
      </div>

      <div className="mt-12 md:mt-20 px-4 md:px-0">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.7020431697165!2d3.4091637246433706!3d6.432307443558801!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8ad0e0ba4afd%3A0x34c4120b148603c8!2s8A%20Elsie%20Femi%20Pearse%20St%2C%20Victoria%20Island%2C%20Lagos%20106104%2C%20Lagos!5e0!3m2!1sen!2sng!4v1793107089672!5m2!1sen!2sng"
          width="100%"
          height="400"
          className="md:h-[500px] lg:h-[550px] rounded-[15px] md:rounded-[20px]"
          loading="lazy"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
